import styled from 'styled-components';
import { CustomButton } from '@mindly/ui-components';

export const DatesWrapper = styled.ul`
  display: flex;
  border-bottom: 1px solid #eeeeee;
  margin: 0 0 24px 0;
  list-style: none;
  padding: 0;
`;

export const LocalTimeText = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #1d201f;

  margin-bottom: 20px;
`;

export const EmptySlotsWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-self: center;
  width: 100%;
`;

export const EmptyIconWrapper = styled.div`
  margin-bottom: 15px;
`;

export const EmptyMessage = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  color: #1d201f;
  margin-bottom: 10px;
`;

export const EmptyAnotherText = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 20px;
  text-align: center;
  color: #1d201f;
  margin-bottom: 46px;
`;

export const RescheduleLoaderWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 24px;

  & ion-spinner {
    width: 40px;
    height: 40px;
    color: #177590;
  }

  & div {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #1d201f;
    margin-bottom: 2px;
  }
`;

export const DaySliderWrapper = styled.div`
  border-top: 1px solid #eeeeee;

  padding-top: 22px;
  margin-bottom: 22px;
`;

export const ChooseAnotherButton = styled(CustomButton)`
  width: 208px !important;
  margin-bottom: 46px;
`;

export const FrequentlyAskedQuestionsWrapper = styled.div`
  margin-top: 30px;
  align-self: flex-start !important;
`;

export const SpecialistListWrapper = styled.div`
  margin-top: 14px;
  padding-bottom: 29px;
`;
